<template>
  <div class="kd-body">
    <div class="mask" id="mask"></div>
    <div class="banners">
      <div class="banner" style="display: block;">
        <div style="background-image:url(/assets/banners/logtracing_01.jpg?width=1360&amp;height=180)" class="img"></div>
        <div style="background-image:url(/assets/banners/logtracing_02.jpg?width=1360&amp;height=180)" class="img"></div>
        <div style="background-image:url(/assets/banners/logtracing_03.jpg?width=1360&amp;height=180)" class="img"></div>
      </div>
    </div>
    <div class="query-wrap kd-content">
      <div class="kd-clearfix">
        <div class="input-wrap">
          <div class="icon" id="comIcon">
            <img src="/assets/default-com.png">
          </div>
          <input type="text" placeholder="Tra cứu hành trình mã vận đơn" id="input" autocomplete="off"
            v-model="search_term" @change="filter_data">
        </div>
        <v-btn v-if="is_mobile()" style="margin-left: 8px; height: 128px; width: 140px;" color="#FF7f02" @click="onScan"><v-icon color="white" x-large>fa-camera</v-icon></v-btn>
        <div v-else class="button search" id="query" @click="filter_data">Tra cứu</div>
      </div>
      <div class="demo" id="demoWrap">Ví dụ：<a href="#" id="demo"
          @click="search_term = '700721620641'; filter_data()">700721620641</a>
      </div>
      <div class="result-wrap" id="result"
        v-bind:style="{ 'display': !show_result || tracking.length == 0 ? 'none' : 'block' }">
        <div class="close kd-hover" role="close" @click="closeResult"></div>
        <!-- 国内段 -->
        <div id="google_translate_element"></div>
        <div id="internal" v-bind:style="{ 'display': !show_result || tracking.length == 0 ? 'none' : 'block' }"
          role="result">
          <div class="result-body kd-clearfix">
            <div class="result">
              <div class="title">
                <div class="sort" title="Thời gian nhận" role="sort">Thời gian</div>
                <div class="text">Hành trình</div>
              </div>
              <ul class="content">
                <li class="step" v-bind:class="{ 'start': index == 0 }" v-for="(item, index) in tracking" :key="index">
                  <div class="datetime">{{ item.time | display_date }}</div>
                  <div class="step-icon"></div>
                  <div class="text">{{ item.context }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 查询错误 -->
      <div class="query-panel" id="queryPanel"
        v-bind:style="{ 'display': tracking.length == 0 && show_result ? 'block' : 'none' }">
        <div class="close kd-hover" role="close" @click="closeResult"></div>
        <img src="/assets/loading_new.gif" class="loading" v-bind:style="{ 'display': loading ? 'block' : 'none' }">
        <div class="error-wrap" id="errorWrap"
          v-bind:style="{ 'display': tracking.length == 0 && show_result ? 'block' : 'none' }">
          <div class="placeholer">
            <img src="/assets/errors.png" class="error-img">
            <div class="error-text">Không tìm thấy thông tin, vui lòng kiểm tra lại mã vận đơn đã nhập</div>
          </div>
          <div class="error-desc"></div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="kd-content">
        <div class="h1"><span>Đối tác của chúng tôi</span></div>
        <img src="/assets/brand-2.png" class="brand" style="margin-top: 37px;">
      </div>
    </div>
    <div class="section">
      <div class="kd-content">
        <div class="h1"><span>Giới thiệu</span></div>
        <div class="kd-clearfix">
          <img src="/assets/section1.jpg" style="margin-top: 37px;" class="fl" height="300">
          <div class="fr" style="width: 570px; margin-top: 30px;">
            <div class="subtitle">Logtracing</div>
            <div class="text">
              <p>Logtracing là website tra cứu vận trình
                đơn hàng quốc tế nhanh chóng, dễ dàng. Với một cái nhấp chuột duy nhất,
                chúng tôi sẽ đưa bạn vào thế giới của hàng trăm nhà vận chuyển hàng đầu trên thế giới. Bạn có thể theo dõi
                hành trình đơn hàng của mình và biết được trạng thái cập nhật mới nhất chỉ trong nháy mắt.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="kd-content">
        <div class="h1"><span>Sứ mệnh</span></div>
        <div class="kd-clearfix">
          <div class="fl" style="width: 570px; margin-top: 30px;">
            <div class="subtitle">Logtracing</div>
            <div class="text">
              <p>Logtracing là website tra cứu vận trình đơn hàng quốc tế dễ dàng và thuận tiện, giúp người dùng tiết kiệm
                thời gian và nỗ lực khi theo dõi đơn hàng của mình. Chỉ với 1 một chạm, chúng tôi mang đến khả năng tra
                cứu thông tin về mọi đơn hàng quốc tế của nhiều nhà vận chuyển hàng đầu trên thế giới.</p>
            </div>
          </div>
          <img src="/assets/section2.jpg" style="margin-top: 37px;" class="fr" height="300" width="600">
        </div>
      </div>
    </div>
    <div class="section">
      <div class="kd-content">
        <v-carousel cycle>
          <v-carousel-item src="/assets/sliders/slide-qc-1.jpg" cover></v-carousel-item>
          <v-carousel-item src="/assets/sliders/slide-qc-2.jpg" cover></v-carousel-item>
          <v-carousel-item src="/assets/sliders/slide-qc-3.jpg" cover></v-carousel-item>
          <v-carousel-item src="/assets/sliders/slide-qc-4.jpg" cover></v-carousel-item>
        </v-carousel>
      </div>
    </div>
    <div class="modal-qrscan" v-bind:class="{'show': showBarcodeReader}"><div id="qrcode-cam-reader"></div>
      <v-btn v-if="is_mobile()"
        large
        dark color="#FF7f02" style="margin-top: 10px; font-size: 36px; height: 48px;" @click="onCancelScan"><v-icon color="white" x-large>fa-close</v-icon> Đóng</v-btn>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";
import {Html5Qrcode} from "html5-qrcode";

export default {
  data() {
    return {
      search_term: '',
      show_result: false,
      showBarcodeReader: false,
      html5QrcodeScanner: null
    };
  },
  computed: {
    ...mapState({
      current_item: state => state.transactions.selected,
      loading: state => state.transactions.loading
    }),
    tracking() {
      let tmp = [];
      if (_.isEmpty(this.current_item)) {
        return tmp;
      }
      // tracking from CN to VN
      if (this.current_item.VNCode) {
        let cn_routings = this.current_item.Routing ? JSON.parse(this.current_item.Routing) : [];
        tmp = tmp.concat(cn_routings);
        if (this.current_item.StoreVNExportDate) {
          tmp.push({ 'time': this.$options.filters.display_date_tz(this.current_item.StoreVNExportDate, 'YYYY-MM-DD HH:mm:ss'), 'context': `Xuất kho nhận - ${this.current_item.DstStoreName || ''}` });
        }
        if (this.current_item.StoreVNImportDate) {
          tmp.push({ 'time': this.$options.filters.display_date_tz(this.current_item.StoreVNImportDate, 'YYYY-MM-DD HH:mm:ss'), 'context': `Nhập kho nhận - ${this.current_item.DstStoreName || ''}` });
        }
        if (this.current_item.StoreCNExportDate) {
          tmp.push({ 'time': this.$options.filters.display_date_tz(this.current_item.StoreCNExportDate, 'YYYY-MM-DD HH:mm:ss'), 'context': `Xuất kho gửi - ${this.current_item.SrcStoreName || ''} (Đang vận chuyển về kho nhận - ${this.current_item.DstStoreName || ''}, dự kiến ngày ${this.$options.filters.display_date_tz(this.current_item.StoreCNExportDate, 'DD/MM/YYYY', 5)} nhập kho nhận)` });
        }
        if (this.current_item.StoreCNImportDate) {
          tmp.push({ 'time': this.$options.filters.display_date_tz(this.current_item.StoreCNImportDate, 'YYYY-MM-DD HH:mm:ss'), 'context': `Nhập kho gửi - ${this.current_item.SrcStoreName || ''}` });
        }
      }
      else {
        if (this.current_item.StoreVNExportDate) {
          tmp.push({ 'time': this.$options.filters.display_date_tz(this.current_item.StoreVNExportDate, 'YYYY-MM-DD HH:mm:ss'), 'context': `Xuất kho nhận - ${this.current_item.DstStoreName || ''}` });
        }
        if (this.current_item.StoreVNImportDate) {
          tmp.push({ 'time': this.$options.filters.display_date_tz(this.current_item.StoreVNImportDate, 'YYYY-MM-DD HH:mm:ss'), 'context': `Nhập kho nhận - ${this.current_item.DstStoreName || ''}` });
        }
        if (this.current_item.StoreCNExportDate) {
          tmp.push({ 'time': this.$options.filters.display_date_tz(this.current_item.StoreCNExportDate, 'YYYY-MM-DD HH:mm:ss'), 'context': `Xuất kho gửi - ${this.current_item.SrcStoreName || ''} (Đang vận chuyển về kho nhận - ${this.current_item.DstStoreName || ''}, dự kiến ngày ${this.$options.filters.display_date_tz(this.current_item.StoreCNExportDate, 'DD/MM/YYYY', 5)} nhập kho nhận)` });
        }
        if (this.current_item.StoreCNImportDate) {
          tmp.push({ 'time': this.$options.filters.display_date_tz(this.current_item.StoreCNImportDate, 'YYYY-MM-DD HH:mm:ss'), 'context': `Nhập kho gửi - ${this.current_item.SrcStoreName || ''}` });
        }
        let cn_routings = this.current_item.Routing ? JSON.parse(this.current_item.Routing) : [];
        tmp = tmp.concat(cn_routings);
      }
      return tmp;
    }
  },
  methods: {
    is_mobile() {
      return screen.width <= 760;
    },
    filter_data: function () {
      if (this.search_term != '') {
        let param = {
          'tran': this.search_term
        }
        this.$store.dispatch("transactions/getDetailTran", param).then((p) => {
          this.googleTranslateElementInit();
          this.show_result = true;
        });
      }
    },
    googleTranslateElementInit() {
      document.cookie = "googtrans=/auto/vi";
      window.google.translate.TranslateElement(
        { pageLanguage: "cn", includedLanguages: 'vi,en' },
        "google_translate_element"
      );
    },
    closeResult() {
      this.show_result = false;
    },
    onScanSuccess(decodedText, decodedResult) {
      this.onCancelScan();
      console.log(decodedText);
      this.search_term = decodedText;
      this.filter_data();
    },
    onCancelScan() {
      this.showBarcodeReader = false;
      this.html5QrcodeScanner.stop().then((ignore) => {
        // QR Code scanning is stopped.
      }).catch((err) => {
        // Stop failed, handle it.
      });
    },
    onScan() {
      this.showBarcodeReader = true;
      this.html5QrcodeScanner = new Html5Qrcode("qrcode-cam-reader");
      const config = { fps: 10, qrbox: {width: 800, height: 800} };
      // If you want to prefer back camera
      this.html5QrcodeScanner.start({ facingMode: "environment" }, config, this.onScanSuccess);
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$emit('COMPONENT_LOADED');
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
}
</script>
